export default __webpack_public_path__ + "static/media/missingcreative.3324c488.svg";